import React, { DetailedHTMLProps, HTMLAttributes, ReactElement } from 'react';
import { VoxelAlertProps } from '../Alert/VoxelAlert';

export interface VoxelAppBarAlertProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  isScrolling?: boolean;
  voxelAlert?: ReactElement<VoxelAlertProps>;
}

export const VoxelAppBarAlert: React.FC<VoxelAppBarAlertProps> = ({ isScrolling, voxelAlert }) => {
  let bgColor = '';
  if (voxelAlert.props?.severity === 'error') {
    bgColor = 'bg-error-100/80';
  }
  if (voxelAlert.props?.severity === 'warning') {
    bgColor = 'bg-warning-500/20';
  }
  if (voxelAlert.props?.severity === 'info') {
    bgColor = 'bg-info-600/20';
  }
  if (voxelAlert.props?.severity === 'success') {
    bgColor = 'bg-success-600/10';
  }
  return (
    <div className={`w-full h-auto flex flex-row ${isScrolling ? 'hidden' : ''} `}>
      <div className={`${bgColor} grow`} />
      <div className="container">{voxelAlert}</div>
      <div className={`${bgColor} grow`} />
    </div>
  );
};

export default VoxelAppBarAlert;
